import CodeEditor from '@uiw/react-textarea-code-editor';
import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import './style.css';


const mapStateToProps = state => ({
  appLanguage: state.app.language
});

const CodeEditorTextArea = ({
                        onChange,
                        language,
                        style,
                        className,
                        value,
                        placeholder,
                        disabled,
                        onBlur
                      })  => {
    return (
        <CodeEditor
          readOnly={disabled}
          value={value}
          language={language}
          placeholder={placeholder}
          onChange={onChange}
          style={style}
          className={`${className} editor`}
          data-color-mode="light"
          onBlur={onBlur}
        />

    );
  }
  
  export default compose(
    translate(),
    connect(mapStateToProps))(CodeEditorTextArea)